import React from "react";
import Table from "react-bootstrap/Table";
import styles from "./UserUpdateCohort.module.css";
import Dropdown from "react-bootstrap/Dropdown";
import Box from "@mui/material/Box";
import Button from "react-bootstrap/Button";
import { FaArrowLeft } from "react-icons/fa";
import search from "../../../../../assests/search.svg";
import filter from "../../../../../assests/filterIcon.svg";
import Sidebar from "../../../Sidebar/Sidebar";
import { toastr } from "react-redux-toastr";
import { useNavigate } from "react-router-dom";

export const UpdateCohortComp = (props) => {
  const navigate = useNavigate();
  const cohortBack = () => navigate(-1);

  const handleSaveClick = () => {
    props.updateuserCohort();
    navigate(-1);
    toastr.success("Cohort updated successfully");
  };

  return (
    <div className={styles.mainDiv}>
      <Sidebar />

      <div className={styles.mainContent}>
        <div className={styles.topHeader}>
          <FaArrowLeft className={styles.backArrow} onClick={cohortBack} />
          <h2>Update Cohort</h2>
        </div>

        <div className={styles.updateCohortSec}>
          <div className={styles.searchDivision}>
            <input
              type="search"
              placeholder="Search by Cohort Name / Cohort ID"
              onChange={(e) => props.Search(e.target.value)}
            />
            <img className={styles.cohortUpdateSearchIcon} src={search} alt="Search" />
          </div>

          <div className={styles.tableContainer}>
            <Table striped>
              <thead>
                <tr>
                  <th>Cohort ID</th>
                  <th>Cohort Name</th>
                  <th>Area Name</th>
                  <th>
                    <Dropdown className={styles.cohortTypeDropdown}>
                      <Dropdown.Toggle variant="none" id="dropdown-basic" className={styles.cohortDropdownToggle}>
                        <img src={filter} alt="" className={styles.filterIcon} />
                        <span className={styles.dropdownLabel}>Cohort Type</span>
                        <span className={styles.dropdownArrow}>▼</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className={styles.cohortDropdownMenu}>
                        {props.stagecohortsTypes?.map((item) => (
                          <Dropdown.Item
                            key={item.id}
                            id={item.id}
                            className={`${styles.cohortDropdownItem} ${props.activeCohortType === item.id ? styles.activeDropdownItem : ''}`}
                            active={props.activeCohortType === item.id}
                            onClick={() =>
                              props.handleCohortTypeClick(item.id, item.type)
                            }
                          >
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {props.FilterCohortData?.length > 0 &&
                  props.FilterCohortData.sort((a, b) => {
                    const aChecked = props.userdetailsCohort?.find((dt) => dt.id === a.id);
                    const bChecked = props.userdetailsCohort?.find((dt) => dt.id === b.id);
                    return aChecked === bChecked ? 0 : aChecked ? -1 : 1;
                  }).map((el) => (
                    <tr key={el.id}>
                      <td>{el.id}</td>
                      <td>{el.name}</td>
                      <td>{el.area_name}</td>
                      <td className={styles.ctypes}>{el.type}</td>
                      <td>
                        <input
                          id={el.id}
                          type="checkbox"
                          className={styles.cohortCheckbox}
                          onChange={(e) => {
                            if (props.userdetailsCohort?.find((dt) => dt.id === el.id)) {
                              props.removedCohort(e, el.id);
                            } else {
                              props.addCohorthandleClick(e);
                            }
                          }}
                          checked={props.userdetailsCohort?.some((dt) => dt.id === el.id)}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>

          <Box className={styles.usersRoleBtnCohort}>
            <Button className={styles.userUpdateCohortBackBtn} onClick={cohortBack}>
              Back
            </Button>
            <Button className={styles.userUpdateCohortSaveBtnUpdate} onClick={handleSaveClick}>
              Save
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};